import React from "react";
import styled from "styled-components";

//images
import Apple from "../assets/images/apple-3-x@3x.png";
import HawkesSkullBig from "../assets/images/all-hawkes-logos-new-hawkes-logo-eddie-black-copy.svg";

const CideriesSectionContainer = styled.section`
  padding-top: 60px;
  background-image: url(${HawkesSkullBig});
  background-repeat: no-repeat;
  background-position: center top;
`;

const CideriesHeaders = styled.div`
  padding: 50px 0 50px 0;
`;

const Cideries = styled.div`
  padding: 50px 0 50px 0;
`;

const PinkH1 = styled.h1`
  color: #d8127d;
`;

const PinkH2 = styled.h2`
  color: #d8127d;
`;

const PinkH3 = styled.h2`
  color: #d8127d;
`;

const Pinkh4 = styled.h4`
  color: #d8127d;
  text-transform: uppercase;
`;

const MobileImage = styled.img`
  height: ${props => props.height || "100px"};
  width: ${props => props.width || "100px"};
  object-fit: contain;
  margin: ${props => props.margin || "0"};
  @media (min-width: 992px) {
    display: none;
  }
`;

const Location = styled.div`
  padding: 0 0 50px 0;
`;

const LocationList = styled.ul`
  border-top-width: 4px;
  border-top-style: solid;
  padding: 30px 0 30px 0;
`;

const CideriesSection = () => (
  <CideriesSectionContainer>
    <h4>LONDONS'S VERY OWN CRAFT CIDER FESTIVAL RETURNS!</h4>

    <CideriesHeaders>
      <PinkH1>30+ CIDERIES</PinkH1>
      <PinkH2>OVER 80 CIDERS</PinkH2>
      <PinkH3>LONDON MADE STREET FOOD</PinkH3>
      <Pinkh4>BANGING DJS AND LIVE MUSIC</Pinkh4>
    </CideriesHeaders>
    <MobileImage src={Apple} width="241px" height="292px" />
    <Cideries>
      <h4>CIDERIES</h4>
      <Location>
        <h2>UK</h2>
        <LocationList>
          <li>
            <Pinkh4>Announced very soon</Pinkh4>
          </li>
        </LocationList>
      </Location>
      <Location>
        <h2>EUROPE</h2>
        <LocationList>
          <li>
            <Pinkh4>Announced very soon</Pinkh4>
          </li>
        </LocationList>
      </Location>
      <Location>
        <h2>USA</h2>
        <LocationList>
          <li>
            <Pinkh4>Announced very soon</Pinkh4>
          </li>
        </LocationList>
      </Location>
    </Cideries>
  </CideriesSectionContainer>
);

export default CideriesSection;
